export default "__VITE_ASSET__059ead90__"